import src from "IMAGE";
export default { src, width: 548, height: 411, blurWidth: 0, blurHeight: 0};
